/* Package JSON Import will be here */
import React from 'react';
import ImageUploading from 'react-images-uploading';
import { Button, Image, Icon } from 'semantic-ui-react';

import "../../../assets/styles/styles.css";
import "./image-upload.css"


const ImageUploadComponent = props => {

    return (
        <div className="container-fluid">
            <div className="splash-screen">
                <ImageUploading
                    multiple
                    value={props.images}
                    onChange={props.onChange}
                    maxNumber={3}
                    dataURLKey="data_url"
                >
                    {({
                        onImageUpload,
                        onImageRemove,
                        isDragging,
                        dragProps
                    }) => (
                        // write your building UI
                        <div className="upload__image-wrapper">
                            <Button primary class="ui active button"
                                style={isDragging ? { color: "red" } : null}
                                onClick={onImageUpload}
                                {...dragProps}>
                                <i class="cloud upload icon"></i>
                                Upload Image
                            </Button>

                            {props.images && props.images.map((image, index) => (
                                <div key={index} className="image-item">
                                    <div className="image-item__btn-wrapper">
                                        <Icon color='red' name='remove' className="pl-1 text-right pointer" onClick={() => onImageRemove(index)} />
                                    </div>
                                    <Image src={image.data_url} alt="" height="100" width="100" />
                                </div>
                            ))}
                        </div>
                    )}
                </ImageUploading>
            </div>
        </div >
    );
};

ImageUploadComponent.displayName = "ImageUploadComponent";

export default ImageUploadComponent;